/**
 * @generated SignedSource<<f24bf24a1e59624b81c3720d7a97d29f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productDuplicationTaskQueriesDeleteMutation$variables = {
  taskId: number;
};
export type productDuplicationTaskQueriesDeleteMutation$data = {
  readonly deleteProductTask: boolean;
};
export type productDuplicationTaskQueriesDeleteMutation = {
  response: productDuplicationTaskQueriesDeleteMutation$data;
  variables: productDuplicationTaskQueriesDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskId",
        "variableName": "taskId"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteProductTask",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productDuplicationTaskQueriesDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productDuplicationTaskQueriesDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c947ffcb56393ee69fa52d6743eea001",
    "id": null,
    "metadata": {},
    "name": "productDuplicationTaskQueriesDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation productDuplicationTaskQueriesDeleteMutation(\n  $taskId: Long!\n) {\n  deleteProductTask(taskId: $taskId)\n}\n"
  }
};
})();

(node as any).hash = "68bd43b3e8f11eb303d2e0296b614b76";

export default node;
